import React from 'react';
import Globalfilter from './global-filter/global-filter.component';
import Sort from './sort/sort.component';
import useStyles from './toolbar.styles';

const Toolbar = (props) => {

    const classes = useStyles();
 
    return (
        <>
        <div className={classes.root}>
            <Sort handleSortBy={props.handleSortBy}/>
            <Globalfilter 
                preGlobalFilteredRows={props.preGlobalFilteredRows}
                globalFilter={props.globalFilter}
                setGlobalFilter={props.setGlobalFilter}
                dropdownData={props.dropdownData}
            />
         </div>
        </>
    );
}

export default Toolbar;